/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PlanSettingsRemovedIssuesType from '@jira/spa-apps__advanced-roadmaps-plan-settings/src/RemovedIssuesPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - removed-issues page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsRemovedIssues: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof PlanSettingsRemovedIssuesType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-removed-issues", jiraSpaEntry: "async-plan-settings-removed-issues" */ '@jira/spa-apps__advanced-roadmaps-plan-settings/src/RemovedIssuesPage.tsx'
			),
		),
	{ ssr: false },
);

const AsyncPlanSettingsRemovedIssues = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsRemovedIssues}
		pageId="plan-settings-removed-issues"
		shouldShowSpinner
	/>
);

export default AsyncPlanSettingsRemovedIssues;
